import React from "react";
import { CustomFlowbiteTheme, Modal } from "flowbite-react";
import { IoIosWarning } from 'react-icons/io'
import { useNavigate } from "react-router-dom";

interface ModalFileUploadErrorProps {
  message: string;
  img?: string;
  isOpen: boolean
  closeModal: () => void
}

export const ModalFileUploadError = ({ message, img, isOpen, closeModal }: ModalFileUploadErrorProps) => {

  const themeModal: CustomFlowbiteTheme['modal'] = {
    root: {
      base: 'fixed top-0 right-0 left-0 z-40 h-modal h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full'
    }
  }


  return (
    <>
      <Modal
        show={isOpen}
        // show={true}
        popup={true}
        size={"md"}
        onClick={() => closeModal()}
        theme={themeModal}
      >
        <Modal.Body>
          <div className="flex items-center justify-center flex-col p-6">
            <IoIosWarning className="fill-amber-500 m-4" size={70} />
            <p className="font-medium text-center text-lg m-2 text-gray-800 w-full">{message}</p>
            {/* <button type="button" className="bg-primary text-white px-4 py-2 rounded-md mt-4 w-full" onClick={() => onClose(true)}>Fechar</button> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}